import type { ReactElement } from 'react';

import { Flex } from '@rango-dev/whale';
import React from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../../hooks/reduxHooks';
import {
  dispatchCancellableAction,
  fetchProfileSummary,
  showPrivateProfileSelector,
} from '../../../state/ProfileSlice';
import { UnexpectedError } from '../UnexpectedError';

export function ProfileSummaryEmptyState(): ReactElement {
  const params = useParams<{ username: string }>();
  const showPrivateProfile = useAppSelector((state) =>
    showPrivateProfileSelector(state, params.username),
  );
  const dispatch = useAppDispatch();

  const refetchProfileSummary = () => {
    if (params.username) {
      dispatchCancellableAction(dispatch, fetchProfileSummary, {
        username: params.username,
        public: !showPrivateProfile,
      });
    }
  };

  return (
    <Flex direction="column" justify="center" align="center" py="9">
      <UnexpectedError context="profile-page-profile-summary" onRetry={refetchProfileSummary} />
    </Flex>
  );
}
